export default __webpack_public_path__ + "static/media/docManagement.9bcfe305.svg";